var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useContext, useEffect, useState } from "react";
import { Stack } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import LinkEditorForm from "../LinkEditorForm";
import { useForm } from "react-hook-form";
import { Context } from "../../../context";
import { StyleControlButton } from "../../Molecules";
import { getLinkSelectionData, insertLink, isLinkActive, } from "../../../helpers";
import { ReactEditor, useSlate } from "slate-react";
import { Dialog } from "../../../../../Molecules";
var LinkEditor = function (_a) {
    var last = _a.last;
    var _b = useContext(Context), linkDialogOpen = _b.linkDialogOpen, setLinkDialog = _b.setLinkDialog, linkData = _b.linkData, setLinkData = _b.setLinkData;
    var _c = __read(useState(false), 2), isExistingLink = _c[0], setIsExistingLink = _c[1];
    var editor = useSlate();
    var methods = useForm({
        criteriaMode: "all",
        mode: "onTouched",
        defaultValues: {
            text: "",
            link: "",
        },
    });
    var isFocused = ReactEditor.isFocused(editor);
    var getValues = methods.getValues, isValid = methods.formState.isValid;
    var closeDialog = useCallback(function () {
        setLinkDialog(false);
        setLinkData({
            link: "",
            text: "",
        });
        methods.reset({
            link: "",
            text: "",
        });
    }, []);
    useEffect(function () {
        if (linkData.link || linkData.text) {
            setIsExistingLink(true);
            methods.reset({
                link: linkData.link,
                text: linkData.text,
            });
        }
    }, [linkData]);
    /**
     * submit form in dialog
     */
    var onSave = function () {
        var _a = getValues(), link = _a.link, text = _a.text;
        // append http:// if URL doesn't contain http or https
        var updatedLink = link;
        var httpRegex = new RegExp("^(http|https)://", "i");
        if (link.length > 0 && !httpRegex.test(link)) {
            updatedLink = "http://".concat(link);
        }
        // depending on if user entered a link either add the link or remove the existing link
        if (isExistingLink || updatedLink) {
            insertLink(editor, updatedLink, text);
        }
        closeDialog();
    };
    /**
     * Submit cta for adding a link
     */
    var buttonActions = useMemo(function () {
        return [
            {
                form: "wysiwyg-link-form",
                label: "Save",
                disabled: !isValid,
                onClick: onSave,
            },
        ];
    }, [isValid]);
    /**
     * open prompt for link inputs
     */
    var promptForLink = function (event) {
        event.preventDefault();
        // get link at current selection if one exists
        var linkData = getLinkSelectionData(editor);
        setIsExistingLink(!!linkData.link);
        methods.reset({
            text: linkData.text,
            link: linkData.link,
        });
        setLinkDialog(true);
    };
    /**
     * Theres a required click listener to focus wysiwyg, we need to stop the bubble so this flow doesnt trigger it
     */
    var stopBubble = useCallback(function (e) {
        e.stopPropagation();
    }, []);
    return (_jsxs(Stack, __assign({ direction: "row", alignItems: "center", onClick: stopBubble, "data-testid": "lintbtn-wrapper" }, { children: [_jsx(StyleControlButton, { active: isLinkActive(editor), onMouseDown: promptForLink, Icon: LinkIcon, label: "Link", isFocused: isFocused, testId: "link-btn-wysiwyg", last: last }), _jsx(Dialog, { titleTextVariant: "subtitle1", title: "Add link", "data-testid": "wysiwyg-info-dialog", handleClose: closeDialog, content: _jsx(LinkEditorForm, { methods: methods, onSubmit: onSave }), open: linkDialogOpen, buttonActions: buttonActions, PaperProps: {
                    sx: {
                        width: "100%",
                        maxWidth: 662,
                    },
                } })] })));
};
export default LinkEditor;
